import { render, staticRenderFns } from "./PayableReceivableCreateUpdate.vue?vue&type=template&id=4764efc5&"
import script from "./PayableReceivableCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports